import * as yup from "yup";

const quadrantSchema  = (translate: Function) => yup.object().shape({
	caa002Codigo: yup.string().required(translate("Código é requerido")),
	caa002Descricao: yup.string().required(translate("Descrição é requerida")),
	caa002Cor: yup.string().required(translate("Cor é requerida")),
	caa002Explicacao: yup.string()
});

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	caa001Codigo: yup.string().required(translate("Código é requerido")),	
	caa001Descricao: yup.string().required(translate("Descrição é requerida")),
	caa001Situacao: yup.boolean(),
	catba002: yup.array().of(quadrantSchema(translate)).required(translate("Ao menos um quadrante deve ser informado"))
});

export default addAndChangeSchema;
